import { type BillingUserInfo, useBillingConfig } from './use-billing-config.hook'
import { useBillingOperations } from './use-billing-operations.hook'
import { type RecordUsageParams, useLedgerApi } from './use-ledger-api.hook'
import { usePaymentApi } from './use-payment-api.hook'
import { useSubscriptionApi } from './use-subscription-api.hook'
import { useTenantApi } from './use-tenant-api.hook'

export type { BillingUserInfo, RecordUsageParams }

export const useBillingClient = () => {
  const { orgId, userInfo } = useBillingConfig()
  const tenantApi = useTenantApi()
  const ledgerApi = useLedgerApi()
  const paymentApi = usePaymentApi()
  const subscriptionApi = useSubscriptionApi()
  const billingOps = useBillingOperations()

  return {
    orgId,
    userInfo,
    getTenantClient: tenantApi.getTenantClient,
    syncTenant: tenantApi.syncTenant,
    getCurrentTenant: tenantApi.getCurrentTenant,
    refetchTenant: tenantApi.refetchTenant,
    getLedgerClient: ledgerApi.getLedgerClient,
    getBalance: ledgerApi.getBalance,
    refetchBalance: ledgerApi.refetchBalance,
    getUsageHistory: ledgerApi.getUsageHistory,
    recordUsage: ledgerApi.recordUsage,
    getPaymentMethodsClient: paymentApi.getPaymentMethodsClient,
    setupPaymentMethodCheckout: paymentApi.setupPaymentMethodCheckout,
    getPaymentMethods: paymentApi.getPaymentMethods,
    setDefaultPaymentMethod: paymentApi.setDefaultPaymentMethod,
    deletePaymentMethod: paymentApi.deletePaymentMethod,
    getSubscriptionsClient: subscriptionApi.getSubscriptionsClient,
    getSeatsClient: subscriptionApi.getSeatsClient,
    getPlans: subscriptionApi.getPlans,
    subscribe: subscriptionApi.subscribe,
    cancelSubscription: subscriptionApi.cancelSubscription,
    getBillingClient: billingOps.getBillingClient,
    topUp: billingOps.topUp,
    topUpSession: billingOps.topUpSession,
    redeemCode: billingOps.redeemCode,
    listInvoices: billingOps.listInvoices,
    getAutoTopUpConfig: billingOps.getAutoTopUpConfig,
    upsertAutoTopUpConfig: billingOps.upsertAutoTopUpConfig,
    deleteAutoTopUpConfig: billingOps.deleteAutoTopUpConfig,
  }
}
